import { createContext, useContext, useEffect, useMemo, useState } from "react";
import UserSessionData from "../models/UserSessionData";

import { GetDefaultLanguage, GetLanguageInUrl, IsLaguagePresentInUrl } from "../utils/urls";


const defaultSessionData: UserSessionData = {
    "sessionId": "",
    "userData": {
        "id": "",
        "name": "",
        "surname": "",
        "secondSurname": "",
        "uaid": "",
        "avatar": "",
        "email": "",
        "phone": "",
        "username": "",
        "market": "",
        "role": "",
        "typeAccount": "",
        "idOrganization": "",
        "notifyEmail": null,
        "currency": "",
        "addressOrganization": "",
        "nameOrganization": "",
        "tPVAssigned": null,
        "commissionConfigurationSelected": null
    },
    "isLogged": false,
}
const SessionDataContext = createContext<{
    sessionData: UserSessionData,
    setSessionData: React.Dispatch<React.SetStateAction<UserSessionData>>,
    initialized: boolean
}>({
    sessionData: defaultSessionData,
    setSessionData: () => {},
    initialized: false
});
export const SessionDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [sessionInfo, setSessionInfo] = useState<UserSessionData>(defaultSessionData);
    const [initialized, setInitialized] = useState(false);

    const checkPage = (): void => {
        var path = window.location.pathname;
        const lang: string = IsLaguagePresentInUrl() ? GetLanguageInUrl() : GetDefaultLanguage();

        if (path.indexOf("private") !== -1) {
            //Está en una página privada, le enviamos a la página de 403
            window.location.href = `${lang}/forbiden/no-session-found`;
        }
        // EOC está en una página pública, no pasa nada.
    }

    useEffect(() => {
        const sessionData = sessionStorage.getItem("user-data");
        if (sessionData) {
            setSessionInfo(JSON.parse(sessionData) as UserSessionData);
        } else {
            checkPage();
        }
    }, []);

    return (
        <SessionDataContext.Provider value={{ sessionData: sessionInfo, setSessionData: setSessionInfo, initialized }}>
            {children}
        </SessionDataContext.Provider>
    )
}

export const useSessionData = () => {
    const { sessionData, setSessionData } = useContext(SessionDataContext);
    return useMemo(() => ({ ...sessionData, setSessionData }), [sessionData, setSessionData]);
};
